import React from "react";
import ReactDOM from "react-dom/client";
import "antd/dist/antd.min.css";

import App from "./App";
import "styles/index.scss";
import "assets/index.global.scss";
import "i18n/i18n";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
